module.exports = __webpack_public_path__ + "img/dne-exchange-sm.b0a1dd8b.jpg";